import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

import {
    Pillar,
    PillarComparison,
} from './dual-chart-performance-comparison.widget.model';

export interface ExtMetricFocusPillar {
    userId: number;
    displayType: string;
    variance: number;
    actual: number;
    targetValue: number;
    rankOrder: number;
    trendClass: string;
    thresholdClass: string;
    thresholdTitle: string;
}

export interface MetricFocusPillar extends Pillar {
    variance: number;
    rankOrder: number;
}

export interface MetricFocus extends PillarComparison {}

class MetricFocusPillarModelTransformer
    implements ModelTransformer<MetricFocusPillar, ExtMetricFocusPillar>
{
    transform(model: ExtMetricFocusPillar): MetricFocusPillar {
        return {
            title: model.displayType,
            variance: model.variance,
            actual: model.actual,
            targetValue: model.targetValue,
            rankOrder: model.rankOrder,
            trendClass: model.trendClass,
            thresholdClass: model.thresholdClass,
            thresholdTitle: model.thresholdTitle,
        };
    }
}

class MetricFocusPillarModelSetTransformer extends ModelSetTransformer<
    MetricFocusPillar,
    ExtMetricFocusPillar
> {
    protected newTransformer(): ModelTransformer<
        MetricFocusPillar,
        ExtMetricFocusPillar
    > {
        return new MetricFocusPillarModelTransformer();
    }
}

export class MetricFocusModelTransformer
    implements ModelTransformer<MetricFocus[], ExtMetricFocusPillar[]>
{
    transform(model: ExtMetricFocusPillar[]): MetricFocus[] {
        const pillars = new MetricFocusPillarModelSetTransformer().transform(
            model,
        );
        const transformed: MetricFocus[] = [];
        pillars.forEach((value) => {
            // TODO consolidate actual
            let actual = 0;
            if (value.actual != null && value.targetValue != null) {
                actual =
                    1 +
                    ((value.actual - value.targetValue) / value.targetValue) *
                        (value.rankOrder === 0 ? -1 : 1);
            }
            transformed.push({
                piePillar: value,
                d3: {
                    data: {
                        pie: [
                            {
                                x: value.thresholdTitle, // TODO revise
                                y: actual,
                                color: value.thresholdClass,
                            },
                            {
                                x: '', // TODO revise tl
                                y: Math.min(Math.max(1 - actual, 0), 1),
                                color: 'grey',
                            },
                        ],
                        bar: null,
                    },
                },
            });
        });

        return transformed;
    }
}

export function validateMetricFocus(model: MetricFocus[]): void {
    const valid =
        model != null &&
        model.length !== 0 &&
        model.find((value) => value.piePillar == null) == null;
    if (!valid) {
        throw new Error('MetricFocus not valid');
    }
}
